import { render } from "./redirectBack.vue?vue&type=template&id=5eebcddd&scoped=true"
import script from "./redirectBack.vue?vue&type=script&lang=js"
export * from "./redirectBack.vue?vue&type=script&lang=js"

import "./redirectBack.vue?vue&type=style&index=0&id=5eebcddd&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eebcddd"]])

export default __exports__